/** Cover Wikimedia — Procida e Capri */
export const PROCIDA_CAPRI_HERO_BY_SLUG = {
  procida:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Procida_-_Marina_Corricella.jpg/1280px-Procida_-_Marina_Corricella.jpg",
  capri:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Faraglioni_%28Capri%29.jpg/1280px-Faraglioni_%28Capri%29.jpg",
};
